import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PriorityQueue = ({ title, items, onViewAll, onItemClick }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'bg-error text-error-foreground';
      case 'medium': return 'bg-warning text-warning-foreground';
      case 'low': return 'bg-success text-success-foreground';
      default: return 'bg-muted text-muted-foreground';
    }
  };

  const getAgingColor = (hours) => {
    if (hours > 24) return 'text-error';
    if (hours > 12) return 'text-warning';
    return 'text-muted-foreground';
  };

  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-foreground">{title}</h3>
          <Button variant="ghost" onClick={onViewAll} iconName="ArrowRight" iconPosition="right" iconSize={16}>
            View All
          </Button>
        </div>
      </div>
      <div className="divide-y divide-border">
        {items?.length === 0 ? (
          <div className="p-6 text-center">
            <Icon name="CheckCircle" size={48} className="mx-auto text-success mb-2" />
            <p className="text-muted-foreground">No items in queue</p>
          </div>
        ) : (
          items?.map((item) => (
            <div
              key={item?.id}
              className="p-4 hover:bg-muted/50 cursor-pointer transition-colors duration-150"
              onClick={() => onItemClick(item)}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(item?.priority)}`}>
                    {item?.priority?.toUpperCase()}
                  </div>
                  <div>
                    <p className="font-medium text-foreground">{item?.title}</p>
                    <p className="text-sm text-muted-foreground">{item?.description}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className={`text-sm font-medium ${getAgingColor(item?.agingHours)}`}>
                    {item?.agingHours}h ago
                  </p>
                  <p className="text-xs text-muted-foreground">{item?.type}</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default PriorityQueue;